import styles from "./ToggleUltimateButton.module.scss"
import useStrings from "../../../localization/useStrings"
import { useExpiration } from "../../../context/expirationContext"
import native from "../../../native/native"
import useQueryParams from "../../../hooks/useQueryParams"
import { useUltimateAlerts } from "../../../context/ultimateAlertsContext"

const ToggleUltimateButton = () => {
  const strings = useStrings()
  const { state, actions } = useExpiration()
  const showUltimateInExpiration = useQueryParams().showUltimateInExpiration

  const alertActions = useUltimateAlerts().actions

  if (!state.canToggleUltimate) return null

  let toggleTitle = state.didToggleUltimate
    ? strings.expiration.warmup.switchToPremium
    : strings.expiration.warmup.switchToUltimate

  if (showUltimateInExpiration) {
    toggleTitle = strings.comparePlans.title
  }

  return (
    <button
      className={styles.switchButton}
      onClick={() => {
        if (showUltimateInExpiration) {
          alertActions.setShowComparePlansSheet(true)
        } else {
          actions.toggleUltimate()
          native.logMixpanelEvent("html_expiration_plan_switch", {
            isUltimate: state.isUltimate,
          })
        }
      }}
    >
      {toggleTitle}
    </button>
  )
}

export default ToggleUltimateButton
